module.exports = __webpack_public_path__ + "4d0bbcbca0b31db1b09a5a28078e3b74.jpg";